export const languagePages = [
    ['https://cityrelay.com/', 'https://cityrelay.com/fr/', 'https://cityrelay.com/es/'],
    ['https://cityrelay.com/fr/gestion-airbnb-paris/', 'https://cityrelay.com/', 'https://cityrelay.com/es/'],
]